import React from 'react'

import { getSocialThumbMatchMaker } from '../../../utils/helpers'

const PsychologistList = ({ psychologists }) => {
  return (
    <div className='psychologist-list mb-3'>
      <div>
        {psychologists.thumbs.slice(0, 11).map((thumb, index) => (
          <img
            key={index}
            className='psychologist-list__image'
            src={getSocialThumbMatchMaker(thumb)}
          />
        ))}
      </div>
      <span className='psychologist-list__label'>
        {psychologists.number} Psicólogos <span className='font-bold'>compatíveis</span>
      </span>
    </div>
  )
}

export { PsychologistList }
